import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectors, setFilterSubject } from './../features/schools/slice';
import SideBar from './sideBar/index';
import Map from '../features/map/container';
import SchoolsMap from '../features/schools/map';
import { makeStyles } from '@material-ui/core/styles';
import YearFilter from './filters/year';
import SubjectFilter from './filters/subject';
import ParticipantCountFilter from './filters/participantCount';
import Typography from '@material-ui/core/Typography';
import {Logo, LAKIFALogo, LIKTALogo} from './icons/index';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
	logo: {
        backgroundColor: '#d43e2a',
        height: '80px',
        width: '280px',
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
	},
    additionalLogo: {
        backgroundColor: '#ffffff',
        height: '80px',
        width: '280px',
        position: 'absolute',
        top: '80px',
        right: 0,
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
	},
    logoBox: {
        width: '220px',
        height: 'auto',
        margin: '0 auto'
    },
    legendTitle: {
        fontWeight: 400
    },
    jslogo: {
        position:'absolute', 
        width: '40px',
        height: '40px', 
        margin: '4px 4px 4px 0px',
        bottom: 0,
        right: 0
    },
    legend: {
        padding: '5px'
    },
	divider: {
		margin: '6px 0',
	},
    title: {
        backgroundColor: 'white',
        padding: '7px 10px',
        textAlign: 'center',
        borderBottom: '1px solid #e9e9e9'
    },
    dataAnot: {
        fontSize: '0.9',
        position: 'absolute', 
        bottom: 2,
        right: 50,
    },
    dataAnotLink: {
        color: 'rgba(0, 0, 0, 0.75)',
        textDecoration: 'none'
    },
    filters: {
        borderBottom: '1px solid #e9e9e9'
    },
    circle: {
        border: '2px solid #333',
        borderRadius: 12,
        width: 12,
        height: 12,
        marginBottom: '2px',
        margin: '0 auto'
    },
    circle2: {
        backgroundColor: '#333',
        borderRadius: 12,
        width: 12,
        height: 12,
        marginBottom: '2px'
    },
    circleSmall: {
        borderRadius: 12,
        width: 8,
        height: 8
    },
    circleMedium: {
        borderRadius: 18,
        width: 18,
        height: 18
    },
    circleLarge: {
        borderRadius: 20,
        width: 26,
        height: 26
    },
    circleVeryLarge: {
        borderRadius: 30,
        width: 34,
        height: 34
    },
    legendIcon: {
        verticalAlign:'bottom',
        alignItems: 'flex-end'
    },
    legendIcon2: {
        verticalAlign:'top',
        paddingTop: '1px'
    },
    legendText: {
        verticalAlign:'bottom',
        paddingLeft: 5,
        height: '40px',
        fontSize: '0.8em',
    },
    legendText2: {
        fontSize: '0.8em',
        verticalAlign:'top',
        padding: '0 0 5px 5px',
    },
    smallHeight: { height: '20px'},
    legendSubTitle: {paddingLeft: '3px'},
    legendTable: {marginBottom: '15px'}
}));

const App = () => {

    const classes = useStyles();
    const dispatch = useDispatch();

    if (window.location.search == '?subject=kim') {
        dispatch(setFilterSubject('KIM'));

    } else if (window.location.search == '?subject=mat') {
        dispatch(setFilterSubject('MAT'));

    } else if (window.location.search == '?subject=mat_opt') {
        dispatch(setFilterSubject('MAT_opt'));

    } else if (window.location.search == '?subject=mat_visp') {
        dispatch(setFilterSubject('MAT_visp'));

    } else {
        dispatch(setFilterSubject('FIZ'));
    }

    const filterSubject = useSelector(selectors.filterSubject);
    let additionalLogo = '';

    if (filterSubject == 'MAT' || filterSubject == 'MAT_opt' || filterSubject == 'MAT_visp') {
        additionalLogo = <div className={classes.additionalLogo}><div className={classes.logoBox}><LIKTALogo /></div></div>;
    
    } else if (filterSubject == 'KIM') {
        additionalLogo = <div className={classes.additionalLogo}><div className={classes.logoBox}><LAKIFALogo /></div></div>;
    }

    return <div>
        <div className={classes.logo}><div className={classes.logoBox}><Logo /></div></div>
        {additionalLogo}
        
        <SideBar pos="left">
            <div className={classes.title}>
                <Typography variant="subtitle1">{'Centralizētā eksāmena kārtotāji vidusskolās un ģimnāzijās.'.toUpperCase()}</Typography>
            </div>
            <div className={classes.filters}>
                <YearFilter />
                <SubjectFilter />
                <ParticipantCountFilter />
            </div>
            <div className={classes.legend}>
                <table className={classes.legendTable}>
                    <tr><td className={classes.legendIcon}><div className={clsx(classes.circle, classes.circleSmall)}></div></td><td className={clsx(classes.legendText)}>0 kārtotāji</td></tr>
                    <tr><td className={classes.legendIcon}><div className={clsx(classes.circle)}></div></td><td className={clsx(classes.legendText)}>1 kārtotājs</td></tr>
                    <tr><td className={classes.legendIcon}><div className={clsx(classes.circle, classes.circleMedium)}></div></td><td className={classes.legendText}>2 līdz 9 kārtotāji</td></tr>
                    <tr><td className={classes.legendIcon}><div className={clsx(classes.circle, classes.circleLarge)}></div></td><td className={classes.legendText}>10 līdz 19 kārtotāji</td></tr>
                    <tr><td className={classes.legendIcon}><div className={clsx(classes.circle, classes.circleVeryLarge)}></div></td><td className={classes.legendText}>20 un vairāk kārtotāji</td></tr>
                </table>

                <table>
                    <tr><td className={classes.legendIcon2}><div style={{backgroundColor: '#ff0000'}} className={clsx(classes.circle2)}></div></td><td className={clsx(classes.legendText2, classes.smallHeight)}>neviens skolēns nav kārtojis eksāmenu</td></tr>
                    <tr><td className={classes.legendIcon2}><div style={{backgroundColor: '#ffa500'}} className={clsx(classes.circle2)}></div></td><td className={clsx(classes.legendText2, classes.smallHeight)}>eksāmens ir kārtots, bet nevienam skolēnam rezultāts nav augstāks par 60%</td></tr>
                    <tr><td className={classes.legendIcon2}><div style={{backgroundColor: '#008000'}} className={clsx(classes.circle2)}></div></td><td className={clsx(classes.legendText2, classes.smallHeight)}>eksāmens ir kārtots un vismaz vienam skolēnam rezultāts ir augstāks par 60%</td></tr>
                </table>
            </div>
        </SideBar>
        <Map />
        <div className={classes.dataAnot}><a className={classes.dataAnotLink} target="_blank" href="http://visc.gov.lv" alt="visc">Dati no visc.gov.lv</a></div>
        <img src="logojs.png" target="_blank" alt="Jāņa Sēta" className={classes.jslogo} />
        <SchoolsMap />
    </div>;
}

export default App;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/components/App.js